import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

const circleAttributes = [
	{
		cx: '16.5859',
		cy: '3.27227',
		transform: 'rotate(45 16.5859 3.27227)'
	},
	{
		cx: '27.1924',
		cy: '6.80773',
		transform: 'rotate(45 27.1924 6.80773)'
	},
	{
		cx: '30.7275',
		cy: '17.4144',
		transform: 'rotate(45 30.7275 17.4144)'
	},
	{
		cx: '27.1924',
		cy: '26.6067',
		transform: 'rotate(45 27.1924 26.6067)'
	},
	{
		cx: '17.293',
		cy: '30.8494',
		transform: 'rotate(45 17.293 30.8494)'
	},
	{
		cx: '7.39355',
		cy: '26.6067',
		transform: 'rotate(45 7.39355 26.6067)'
	},
	{
		cx: '3.15039',
		cy: '16.7073',
		transform: 'rotate(45 3.15039 16.7073)'
	},
	{
		cx: '7.39355',
		cy: '6.80743',
		transform: 'rotate(45 7.39355 6.80743)'
	}
];

const Preloader = ({ className, speed, height }) => {
	const [circleIndex, setCircleIndex] = useState(0);

	useEffect(() => {
		const changeCircleIndex = () => {
			setCircleIndex((prev) =>
				prev === circleAttributes.length - 1 ? 0 : prev + 1
			);
		};
		const handle = setInterval(changeCircleIndex, speed);

		return () => clearInterval(handle);
	}, []);

	return (
		<div className={cx(styles.preloader, className)} style={{ height }}>
			<svg className={styles.icon} viewBox="0 0 34 34">
				{circleAttributes.map((attributes, index) => (
					<circle
						// eslint-disable-next-line react/no-array-index-key
						key={index}
						className={cx(
							styles.circle,
							index === circleIndex && styles.animate
						)}
						{...attributes}
					/>
				))}
			</svg>
		</div>
	);
};

Preloader.propTypes = {
	className: PropTypes.string,
	height: PropTypes.string,
	speed: PropTypes.number
};

Preloader.defaultProps = {
	speed: 200
};

export default Preloader;
